import React, { Component } from 'react';
import Tabs from '@tencent/dui/lib/components/Tabs';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { TabPanelIconMap, TabPanelNameMap } from '@framework/workbench/drawer/components/drawer-top-tab/constants';
import Styles from './index.less';
import { DrawerName } from '@framework/workbench/drawer/constants';
import { IReactionDisposer, reaction } from 'mobx';

export default class DrawerTopTab extends Component<any, any> {
    private reaction: IReactionDisposer;
    public componentDidMount() {
        this.getAppServices().editableServiceLayer?.drawerStateManager.promise().then((drawerStateManager) => {
            this.reaction = reaction(() => drawerStateManager.openedDrawers.length, () => {
                this.forceUpdate();
            });
        });
    }

    public componentWillUnmount() {
        this.reaction();
    }

    public render() {
        const openedDrawer = this.getAppServices().editableServiceLayer?.drawerStateManager
            .dangerousInstance?.openedDrawers ?? [];
        const currentDrawer = this.getAppServices().editableServiceLayer?.drawerStateManager
            .dangerousInstance?.currentDrawer;

        return (
            <React.Fragment>
                <div style={{ height: '100%' }}>
                    {
                        (openedDrawer.length > 1 && currentDrawer) ? <Tabs style={{ height: '100%' }} onChange={this.handleTabChange}
                            contentClassName={Styles['content-style']}
                            tabBarClassName={Styles['tab-bar-style']}
                            activeItemClassName={Styles['active-item-style']}
                            indicatorClassName={Styles['indicator-style']}
                            tabBarItemClassName={Styles['tab-bar-item-style']}
                            tabBarItemStyle={{ margin: 0 }}
                            activeId={currentDrawer}>
                            {
                                openedDrawer.map((drawer) => {
                                    const isActive = currentDrawer === drawer;
                                    const title = isActive ? undefined : TabPanelNameMap[drawer];
                                    const iconStyle = isActive ? undefined : {
                                        marginRight: 4,
                                    };
                                    const icon = <img
                                        src={TabPanelIconMap[drawer]}
                                        className={Styles['icon-style']}
                                        style={iconStyle}
                                        draggable={false}
                                    />;
                                    return <Tabs.TabPane tab={title} id={drawer} key={drawer} icon={icon} style={{ height: '100%' }}>
                                        {this.props.children}
                                    </Tabs.TabPane>;
                                })
                            }
                        </Tabs>
                            : this.props.children
                    }
                </div>
            </React.Fragment>
        );
    }

    private handleTabChange = (id) => {
        const { editableServiceLayer, viewableServiceLayer } = this.getAppServices();
        if (!editableServiceLayer) return;

        if (id === DrawerName.SLIDE_PROPERTY_DRAWER) {
            editableServiceLayer.rightSideBarManager.setIsPropertyEditorShown(true);
        } if (id === DrawerName.ANIMATION_RIGHT_DRAWER) {
            editableServiceLayer.rightSideBarManager.setIsAnimationEditorShown(true);
        } if (id === DrawerName.SELECT_WINDOW_RIGHT_DRAWER) {
            editableServiceLayer.rightSideBarManager.setIsSelectWindowShown(true);
        } else if (id === DrawerName.COMMENT_DRAWER) {
            viewableServiceLayer.commentManager.promise().then((commentManager) => {
                commentManager.setIsCommentDrawerShown(true);
            });
        }
    };

    private getAppServices(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IPcEditorAppServices;
    }
}
